var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.tableData, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g0 =
      item.order_master && item.order_master.order_source == 70
        ? (
            item.order_master.pay_price * 1 +
            item.order_master.advance.pay_price * 1
          ).toFixed(2)
        : null
    return {
      $orig: $orig,
      g0: g0,
    }
  })
  var g1 = _vm.tableData.length == 0 && !_vm.loading
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        g1: g1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }